export const EMPTY_PRICES = 'Prices/EMPTY_PRICES';
export const SET_PRICES = 'Prices/SET_PRICES';

export const FETCH_PRICES = 'Prices/FETCH_PRICES';
export const FETCH_PRICES_SUCCESS = 'Prices/FETCH_PRICES_SUCCESS';
export const FETCH_PRICES_FAILURE = 'Prices/FETCH_PRICES_FAILURE';

export const SAVE_PRICES = 'Prices/SAVE_PRICES';
export const SAVE_PRICES_SUCCESS = 'Prices/SAVE_PRICES_SUCCESS';
export const SAVE_PRICES_FAILURE = 'Prices/SAVE_PRICES_FAILURE';



// WEBPACK FOOTER //
// ./src/containers/PricesPage/store/constants.js